import { render, staticRenderFns } from "./ResourcesPage.vue?vue&type=template&id=dc833ac0&scoped=true&"
import script from "./ResourcesPage.vue?vue&type=script&lang=js&"
export * from "./ResourcesPage.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesPage.vue?vue&type=style&index=0&id=dc833ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc833ac0",
  null
  
)

export default component.exports